module.exports = __webpack_public_path__ + "static/media/sonLogo2.29be4a3d.png";